<template>
  <v-row>
    <v-col cols="12" :md="8" :sm="7">
      <EditInterview v-if="isEdit" @setEdit="setEdit" :course="course.id" />
      <v-row no-gutters v-else>
        <v-col cols="12" :md="12" :sm="12">
          <v-row no-gutters justify="space-between">
            <PageTitle :title="$gettext('Directors Interview') + ' ' +  course.name" />
            <v-btn
              :large="$vuetify.breakpoint.md"
              @click="setEdit"
              depressed
              color="primary"
              class="ml-2 mb-3 text-none font-weight-bold subtitle-md-1 subtitle-2"
              v-if="isCourseAdmin"
            >
              <v-icon size="18" class="mr-2">fal fa-pen-to-square</v-icon>
              <translate>Edit</translate>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" class="interview">
          <v-card class="pa-md-6 pa-4">
            <v-row no-gutters class="profile">
              <v-col cols="12" :md="4" :sm="12">
                <v-img
                  max-height="300"
                  min-height="225"
                  :src="currentInterview.photoUrl || pictureUrl(null)"
                ></v-img>
              </v-col>
              <v-col
                cols="12"
                :md="8"
                :sm="12"
                class="pl-0"
                style="align-self: center"
              >
                <div class="name-content">
                  <p class="title text-uppercase font-weight-bold">
                    {{ currentInterview.directorName || $gettext("First & Last name") }}
                  </p>
                  <p class="mb-0">{{ currentInterview.directorPosition || $gettext("Position") }}</p>
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-3">
              <v-col cols="12" class="pt-md-8 pt-3">
                <div
                  v-for="(item, index) in items"
                  :key="index"
                  class="mb-md-5 mb-3 d-flex"
                >
                  <template>
                    <div class="d-flex">
                      <span>{{ index + 1 }} </span>

                      <div>
                        <img
                          :src="iconUrl('polygon.png')"
                          width="7" height="9" class="mx-3"
                        />
                      </div>
                    </div>
                    <div>
                      <span class="font-weight-bold question-title" v-html="item.title"></span>
                      <div
                        v-if="
                          !item.items ||
                            item.items == '<p></p>' ||
                            item.items == null ||
                            item.items == 'null'
                        "
                        v-translate
                        class="grey--text mt-2 font-italic"
                      >Not completed yet</div>

                      <div class="mt-2" v-else>
                        <ContentHTML :content="item.items" :key="isEdit" />
                      </div>
                    </div>
                  </template>
                </div>
              </v-col>
            </v-row>

            <h5
              class="page-subtitle mt-6 pl-3"
              v-if="
                currentInterview.youtube &&
                  currentInterview.youtube.length !== 0
              "
            >
              <translate>Interviews Video</translate>
            </h5>

            <div
              class="mediaGrid-iframe"
              v-if="
                currentInterview.youtube &&
                  currentInterview.youtube.length !== 0
              "
            >
              <iframe
                v-if="isShowIframe"
                type="text/html"
                width="100%"
                height="360"
                :src="`https://www.youtube.com/embed/${currentInterview.youtube[0].youtubeId}?autoplay=1`"
                allow='autoplay'
                frameborder="0"
              />
              <v-img
                v-else
                class="pointer"
                :src="currentInterview.youtube[0].thumbnail"
                :position="'center center'"
                :width="'100%'"
                :height="'100%'"
                cover
                @click="isShowIframe = true"
              >
                <div class="d-flex align-center justify-center fill-height">
                  <div class="buttons" style="z-index: 1">
                    <v-btn color="rgba(255,255,255,.6)" fab icon>
                      <v-icon size="73">fal fa-circle-play</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-img>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" :md="4" :sm="5">
      <DrawerRight />
    </v-col>
  </v-row>
</template>

<script>
import DrawerRight from "@/components/DrawerRight";
import PageTitle from "@/components/PageTitle";
import EditInterview from "@/components/Courses/EditInterview";
import ContentHTML from "@/components/ContentHTML";
export default {
  name: "CoursesInterview",
  metaInfo() {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [
        {
          name: "description",
          content: this.metaDescription,
          vmid: 'description'
        }
      ]
    };
  },
  props: {
    isCourseAdmin: { type: Boolean, default: false }
  },
  components: {
    DrawerRight,
    PageTitle,
    EditInterview,
    ContentHTML
  },
  data() {
    return {
      isEdit: false,
      isShowIframe: false
    };
  },
  async mounted() {
    if (this.course.hasOwnProperty("id")) {
      await this.$store.dispatch("interview/getInterviewData", this.course.id);
    }
  },
  beforeDestroy() {
    let vm = this;
    //reset golf course detail
    vm.$store.commit("setCourseDetail", {});
  },
  computed: {
    currentInterview() {
      let photoUrl = null;
      let youtube = [];
      let interview = this.$store.state.interview.currentInterview;
      if (interview.media && interview.media.length !== 0) {
        interview.media.forEach(media => {
          if (media.type == MEDIA_TYPE_PHOTO) {
            photoUrl = media.thumbnail;
          }
          if (media.type == MEDIA_TYPE_YOUTUBE) {
            youtube.push(media);
          }
        });
      }
      interview.photoUrl = photoUrl;
      interview.youtube = youtube;
      return interview;
    },
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
    items() {
      return [
        {
          action: "mdi-ticket",
          items: (this.currentInterview && this.currentInterview.question1) || "",
          title: this.$gettextInterpolate(this.$gettext("Please tell us a bit about yourself. How long have you been managing %{name}?"),{name: this.course.name})
        },
        {
          action: "mdi-silverware-fork-knife",
          active: true,
          items:
            (this.currentInterview && this.currentInterview.question2) || "",
            title: this.$gettextInterpolate(this.$gettext("What are your main objectives for %{name}?"),{name: this.course.name})
        },
        {
          action: "mdi-silverware-fork-knife",
          active: true,
          items:
            (this.currentInterview && this.currentInterview.question3) || "",
            title: this.$gettextInterpolate(this.$gettext("How would you describe %{name} in a nutshell? What are its key strengths?"),{name: this.course.name})
        },
        {
          action: "mdi-silverware-fork-knife",
          active: true,
          items:
            (this.currentInterview && this.currentInterview.question4) || "",
            title: this.$gettextInterpolate(this.$gettext("Is there any signature hole at %{name}? What makes it special or unique?"),{name: this.course.name})
        },
        {
          action: "mdi-silverware-fork-knife",
          active: true,
          items:
            (this.currentInterview && this.currentInterview.question5) || "",
            title: this.$gettextInterpolate(this.$gettext("Give us your pitch. Why should golfers come to %{name}?"),{name: this.course.name})
        },
        {
          action: "mdi-silverware-fork-knife",
          active: true,
          items:
            (this.currentInterview && this.currentInterview.question6) || "",
            title: this.$gettextInterpolate(this.$gettext("Which special events have been hosted at %{name} and/or will be in the future?"),{name: this.course.name})
        },
        {
          action: "mdi-silverware-fork-knife",
          active: true,
          items:
            (this.currentInterview && this.currentInterview.question7) || "",
            title: this.$gettextInterpolate(this.$gettext("Does %{name} organize its own events or does it plan to do so in the futre? (trophy, challenge, competition, etc.)"),{name: this.course.name})
        }
      ];
    },
    metaTitle() {
      //- namedirector Interview	Director
      const binder = {
        courseName: this.course && this.course.name ? this.course.name : ""
      }
      const translated = this.$gettext("%{courseName} - Interview	Director");
      return this.$gettextInterpolate(translated, binder);
    },
    metaDescription() {
      const binder = {
          courseName: this.course && this.course.name ? this.course.name : "",
          countryName:
            this.course && this.course.country.name
              ? this.course.country.name
              : ""
      }
      const translated = this.$gettext("Director Interviews from %{courseName} golf courses  in %{countryName}, Read about %{courseName} Golf courses vision. Check the interviews at %{courseName}");
      return this.$gettextInterpolate(translated, binder);
    }
  },
  methods: {
    setEdit() {
      this.isEdit = !this.isEdit;
      window.scrollTo(0, 0);
    }
  }
};
</script>

